import { countertop } from "./0-countertop.js";
import { dining } from "./1-dining.js";
import { right } from "./5-right.js";
import { island } from "./2-island.js";
import { range } from "./3-range.js";
import { left } from "./4-left.js";

export const scenesarray = [countertop, dining, island, range, left, right];
